<script>
  import * as restfulService from '../../../../services/restfulService'
  import bus from '@utils/bus'
  import {mapActions} from 'vuex'

  export default {
    mounted () {
      this.checarEmailAcademico()
    },
    data () {
      return {
        data: {
          usuario: {},
          pessoa: {},
          pessoa_fisica: {}
        },
        emailAcademico: '',
        carregandoEmailAcademico: true
      }
    },
    methods: {
      ...mapActions(['showNotification']),
      buscarMeusDados () {
        restfulService.get('pessoa', 'meus-dados')
          .then((response) => {
            this.data.pessoa = response
            this.data.pessoa_fisica = response.pessoa_fisica
            this.data.usuario = response.usuario
            this.carregandoEmailAcademico = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.carregandoEmailAcademico = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      checarEmailAcademico () {
        restfulService.get('usuario', 'checar-email-academico')
          .then((response) => {
            this.emailAcademico = ''
            if (response.email) {
              this.emailAcademico = response.email
            }
            this.buscarMeusDados()
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      criarEmailAcademico () {
        bus.$emit('show-loader')
        restfulService.get('usuario', 'criar-email-academico')
          .then(() => {
            this.checarEmailAcademico()
            this.showNotification({
              message: 'Seu email acadêmico foi criado'
            })
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      alterarSenhaEmailAcademico () {
        bus.$emit('alterar-senha-email-academico')
      }
    }
  }
</script>

<template>
    <div class="meu-perfil">
        <h2 class="meu-perfil-titulo">
            <i class="fas fa-user"></i>
            <span class="pl-2">Perfil</span>
        </h2>

        <div class="perfil-items">
            <div class="perfil-item">
                <div class="perfil-label">E-mail Acadêmico</div>
                <div class="perfil-text" v-if="!carregandoEmailAcademico">
                    <div v-if="emailAcademico">
                        <span>{{emailAcademico}}</span>
                        <v-btn small @click="alterarSenhaEmailAcademico">
                            <i class="fas fa-lock"></i>
                            <span class="pl-2">Alterar Senha</span>
                        </v-btn>
                    </div>
                    <v-btn color="success"
                           @click="criarEmailAcademico()"
                           v-if="!emailAcademico">
                        <i class="fas fa-check"></i>
                        <span class="pl-2">Criar Email Acadêmico</span>
                    </v-btn>
                </div>
                <div class="perfil-text" v-else></div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Celular</div>
                <div class="perfil-text">{{data.pessoa_fisica.fone_celular}}</div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Telefone</div>
                <div class="perfil-text">{{data.pessoa_fisica.fone_residencial || '-'}}</div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Data de Nascimento</div>
                <div class="perfil-text">{{data.pessoa_fisica.dt_nascimento | dateEnToBr}}</div>
            </div>
        </div>

        <h2 class="meu-perfil-titulo">
            <i class="fas fa-bell"></i>
            <span class="pl-2">Notificações e SMS</span>
        </h2>
        <div class="perfil-items">
            <div class="perfil-item">
                <div class="perfil-label">SMS</div>
                <div class="perfil-text">{{data.pessoa_fisica.fl_aceita_sms ? 'Sim' : 'Não'}}</div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Notas</div>
                <div class="perfil-text">{{data.usuario.notificacoes_notas ? 'Sim' : 'Não'}}</div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Provas</div>
                <div class="perfil-text">{{data.usuario.notificacoes_provas ? 'Sim' : 'Não'}}</div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Agenda</div>
                <div class="perfil-text">{{data.usuario.notificacoes_agenda ? 'Sim' : 'Não'}}</div>
            </div>
            <div class="perfil-item">
                <div class="perfil-label">Boletos</div>
                <div class="perfil-text">{{data.usuario.notificacoes_boletos ? 'Sim' : 'Não'}}</div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Inicial.vue?6d5f8a43